'use strict';
const angular = require('angular');

/*@ngInject*/
export function counterService() {
  this.counter = {};
  this.callBacks = [];
  this.setCallBack = function (callback) {
    this.callBacks.push(callback);
  }
  this.triggerChangeCallBack = function () {
    for (let i = 0; i < this.callBacks.length; i++) {
      this.callBacks[i]();
    }
  }
  this.removeCallBacks = function () {
    this.callBacks = [];
  }
}

export default angular.module('nodeApp.counterService', [])
  .service('counterService', counterService)
  .name;



// WEBPACK FOOTER //
// ./client/app/services/counter.service.ts